import {forwardRef} from 'react';

import {SizeTokenValue} from 'common';

import {SVG} from './SVG';

import type {IconComponent} from 'icons/types';

const largeIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M9.5 4C9.22386 4 9 4.22386 9 4.5V6H15V4.5C15 4.22386 14.7761 4 14.5 4H9.5ZM17 6V4.5C17 3.11929 15.8807 2 14.5 2H9.5C8.11929 2 7 3.11929 7 4.5V6H4C3.44772 6 3 6.44772 3 7C3 7.55228 3.44772 8 4 8H5V19.5C5 20.8807 6.11929 22 7.5 22H16.5C17.8807 22 19 20.8807 19 19.5V8H20C20.5523 8 21 7.55228 21 7C21 6.44772 20.5523 6 20 6H17ZM17 8H7V19.5C7 19.7761 7.22386 20 7.5 20H16.5C16.7761 20 17 19.7761 17 19.5V8ZM10 10.25C10.5523 10.25 11 10.6977 11 11.25V17.25C11 17.8023 10.5523 18.25 10 18.25C9.44772 18.25 9 17.8023 9 17.25V11.25C9 10.6977 9.44772 10.25 10 10.25ZM14 10.25C14.5523 10.25 15 10.6977 15 11.25V17.25C15 17.8023 14.5523 18.25 14 18.25C13.4477 18.25 13 17.8023 13 17.25V11.25C13 10.6977 13.4477 10.25 14 10.25Z"
  />
);

const smallIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M6.5 2.0625C6.25838 2.0625 6.0625 2.25838 6.0625 2.5V3.9375H9.9375V2.5C9.9375 2.25838 9.74162 2.0625 9.5 2.0625H6.5ZM11.0625 3.9375V2.5C11.0625 1.63706 10.3629 0.9375 9.5 0.9375H6.5C5.63706 0.9375 4.9375 1.63706 4.9375 2.5V3.9375H2.5C2.18934 3.9375 1.9375 4.18934 1.9375 4.5C1.9375 4.81066 2.18934 5.0625 2.5 5.0625H2.9375V13.5C2.9375 14.3629 3.63705 15.0625 4.5 15.0625H11.5C12.3629 15.0625 13.0625 14.3629 13.0625 13.5V5.0625H13.5C13.8107 5.0625 14.0625 4.81066 14.0625 4.5C14.0625 4.18934 13.8107 3.9375 13.5 3.9375H11.0625ZM11.9375 5.0625H4.0625V13.5C4.0625 13.7416 4.25838 13.9375 4.5 13.9375H11.5C11.7416 13.9375 11.9375 13.7416 11.9375 13.5V5.0625ZM6.5 6.9375C6.81066 6.9375 7.0625 7.18934 7.0625 7.5V11.5C7.0625 11.8107 6.81066 12.0625 6.5 12.0625C6.18934 12.0625 5.9375 11.8107 5.9375 11.5V7.5C5.9375 7.18934 6.18934 6.9375 6.5 6.9375ZM9.5 6.9375C9.81066 6.9375 10.0625 7.18934 10.0625 7.5V11.5C10.0625 11.8107 9.81066 12.0625 9.5 12.0625C9.18934 12.0625 8.9375 11.8107 8.9375 11.5V7.5C8.9375 7.18934 9.18934 6.9375 9.5 6.9375Z"
  />
);

export const DelIcon: IconComponent = forwardRef((props, ref) => {
  const {size} = props;

  return (
    <SVG ref={ref} name="Del" {...props}>
      {!size || size === SizeTokenValue.Large || size === SizeTokenValue.Medium ? largeIcon : smallIcon}
    </SVG>
  );
});
